"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.reports.cost': 'Cost Reports',
    'route.reports.shared': 'Shared Conversations',
    'route.reports.cost.preview': 'Cost Details',
};
